import type { BulkLoads } from '../types'

export function compareLoads(bulkValue: BulkLoads, orderValue: Record<string, number>): BulkLoads {
  let hasAlsoMixedValues = false
  const result: Record<string, number | 'mixed'> = {}

  // First, process loads that exist in bulkValue
  for (const key in bulkValue.value) {
    const bulkLoadValue = bulkValue.value[key]
    const orderLoadValue = orderValue[key]

    // if the orderValue does not have the key, or has different value
    // don't include it in result, just mark as having mixed values
    if (orderLoadValue === undefined || bulkLoadValue !== orderLoadValue) {
      hasAlsoMixedValues = true
      continue
    }

    // Only include loads that have the exact same value across all orders
    result[key] = bulkLoadValue
  }

  // Check if orderValue has loads that are not in the result (loads not in all orders)
  const orderValueHasMoreKeys = Object.keys(orderValue).some(key => result[key] === undefined)
  hasAlsoMixedValues = orderValueHasMoreKeys || hasAlsoMixedValues

  return {
    value: result,
    hasAlsoMixedValues,
  }
}
